import React, { useContext } from 'react';
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { useAsync } from 'react-commons';
import { Dimmer, Loading } from '@galaxy/lorule-react-commons';
import AmDetail from './detail/AmDetail';
import AmList from './amlist/AmList';
import TaskList from './amlist/TaskList';
import WatchList from './amlist/WatchList';
import UserManagement from './admin/userManagement/UserManagement';
import ConfigContext from '../contexts/ConfigContext';
import { getActionMemoCount } from '../api/actionMemoListApi';
import ProjectErrorHandling from './admin/projectErrorHandling/ProjectErrorHandling';
import { AM_LIST_PATH_NAME } from '../utils/Constants';
import StatusChangeRequest from './admin/statusChangeRequest/StatusChangeRequest';

const Index = (routerProps: RouteComponentProps) => {
    const config = useContext(ConfigContext);

    const { search } = routerProps.location;
    const amId = new URLSearchParams(search).get('amId');

    const { value: approvalCount, loading } = useAsync(
        () =>
            getActionMemoCount(config, {
                tasks: true,
            }),
        0,
    );

    const redirect = () => {
        if (amId) {
            return <Redirect to={`/details/${amId}`} />;
        }
        if (approvalCount <= 0) {
            return <Redirect to={AM_LIST_PATH_NAME} />;
        }
        return <Redirect to="/tasks" />;
    };

    return loading ? (
        <>
            <Dimmer />
            <Loading />
        </>
    ) : (
        redirect()
    );
};

const AmRouter = () => (
    <Switch>
        <Route exact path="/index" render={(routerProps) => <Index {...routerProps} />} />
        <Route
            exact
            path={AM_LIST_PATH_NAME}
            render={(routerProps) => <AmList {...routerProps} />}
        />
        <Route exact path="/tasks" render={(routerProps) => <TaskList {...routerProps} />} />
        <Route exact path="/favorites" render={(routerProps) => <WatchList {...routerProps} />} />
        <Route exact path="/details/:id" render={(routerProps) => <AmDetail {...routerProps} />} />
        <Route
            exact
            path="/admin/projectErrorHandling"
            render={(routerProps) => <ProjectErrorHandling {...routerProps} />}
        />
        <Route
            exact
            path="/admin/statusChangeRequest"
            render={(routerProps) => <StatusChangeRequest {...routerProps} />}
        />
        <Route
            exact
            path="/admin/userManagement"
            render={(routerProps) => <UserManagement {...routerProps} />}
        />
    </Switch>
);

export default AmRouter;
